exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".application-bar {\r\n    padding-left: 0;\r\n    margin-left: 0;\r\n    border-bottom: 1px solid #e4eaf0;\r\n}\r\n\r\n.page-title {\r\n    margin-left: 50px;\r\n    border-bottom: 2px solid black;\r\n    padding-bottom: 20px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    margin-bottom: -1px;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n}\r\n\r\n.page-actions {\r\n    margin-bottom: -1px;\r\n}\r\n\r\n/* Using  ::ng-deep to apply this style to child elements. This is an angular specific thing \r\nthat pierces angular's component css/styling seperation. (Usually seperation is a good thing, but here, \r\nit would just lead to duplication). */\r\n::ng-deep .icon-action {\r\n    color: #20ce6e;\r\n}\r\n\r\n::ng-deep .btn-action {\r\n    color: #253d56;\r\n    font-weight: 400;\r\n    opacity: .8;\r\n    font-size: 14px;\r\n}\r\n\r\n::ng-deep .btn-action:hover,\r\n::ng-deep .btn-action:active,\r\n::ng-deep .btn-action:focus {\r\n    color: black;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/shared/components/page-header/page-header.component.css
// module id = ../../../../../src/app/shared/components/page-header/page-header.component.css
// module chunks = main